import { render, staticRenderFns } from "./ksAccTable.vue?vue&type=template&id=1c5bfab6&scoped=true"
import script from "./ksAccTable.vue?vue&type=script&lang=js"
export * from "./ksAccTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5bfab6",
  null
  
)

export default component.exports